export function validateHasNumericalCharacters(value: string) {
  return value && /\d/.test(value);
}
